import { Api, ArrayUtil, ExternalLink, LicenseSettings, LicenseTester } from "@mcleod/core";

export class HelpjuiceLink extends ExternalLink {
    constructor() {
        super("Knowledge Base", null);
    }

    /**
     * Tests whether Helpjuice is licensed, based on the same class that drives the classic menu item.
     */
    public static isLicensed(): boolean {
        // Licensing arrives with the authenticated settings, and LicenseTester can't be called before then.
        // This is reached beforehand because the page header's external links are evaluated on the login page.
        if (LicenseSettings.getSingleton()?.authSettingsPopulated() !== true) {
            return false;
        }
        return LicenseTester.testClass("com.tms.common.loadmaster.helpjuice.HelpjuiceSsoLauncher");
    }

    protected override async resolveURL(): Promise<void> {
        const response = await Api.post("lme/general/helpjuice-url");
        const data = ArrayUtil.getFirstElement(response?.data);
        this.url = data?.url;
    }

    public override async open(): Promise<boolean> {
        const result = await super.open();
        //the token in the url isn't valid for very long, so throw it out
        this.url = null;
        return result;
    }
}
